import {
  authenticationChannel,
  codeBenchActions,
  mergeCasesActions,
  attachDocsActions,
  launchPageActions,
  improvementActions,
  uiActions,
  AmplifyCore,
  sessionManagement,
  caseEditsActions,
  createCaseActions,
  gradeBenchPanelActions,
  coderConfig,
  appServiceLines
} from '@codametrix/ui-common';
import { buildDispatchable } from '../../utils/utils';

const {
  getInvoiceOptions,
  removeTransaction,
  providerSearch
} = AmplifyCore.actions;
const {
  addImprovement,
  removeImprovement,
  improvementSearch,
  updateImprovement,
  addImprovementProvider,
  updateImprovementProvider,
  removeImprovementProvider
} = improvementActions;

const {
  dismissConfirm,
  handleConfirm,
  showConfirm,
  hideFeedback,
  amplifyFeedback
} = uiActions;
const { loadCaseFromId, loadFromURLMatch } = launchPageActions;
const {
  cancelInvoicesPopup,
  clearSearchResults,
  codeAdd,
  codesAdd,
  createTransactionAndAddCode,
  codeRemove,
  codesRemove,
  timeBasedCodeAdd,
  timeBasedCodeUpdate,
  transactionOrderChange,
  codeSearch,
  codeSearchDrop,
  codeUpdate,
  featureSelection,
  fetchProcessInstance,
  navigateDetail,
  popupClose,
  popupNavigate,
  promptClose,
  selectInvoiceToEdit,
  selectInvoiceToAdd,
  submitInvoice,
  openAddChargeModal,
  closeAddChargeModal,
  addTransaction,
  submittedFeedbackTimer,
  deleteSizeExpWarning,
  hideSubmittedFeedback,
  txnSharedCodeAction,
  enableTechPro,
  disableTechPro,
  hidevitalwareIssuesModal,
  showHoldCaseModal,
  hideHoldCaseModal,
  showCaseCommentModal,
  hideCaseCommentModal,
  showExclusionCaseModal,
  hideExclusionCaseModal,
  toggleLateCaseClearModal,
  clearLateCaseNotification,
  showSplitCaseModal,
  hideSplitCaseModal,
  toggleChargeableCase,
  navigatePatient,
  navigateProvider,
  holdCase,
  toggleSubmitOldCaseModal,
  getCaseVersions,
  openWindow,
  loadCursorAPIContext,
  loadRoles,
  getFlagItems,
  getCasesWithEncounter,
  setActiveNote,
  setActiveMiniTab,
  setActiveVerticalMiniTab,
  setUnresolvedDocuments,
  navigateCoderNotes,
  removeInvoice,
  updateRelatedCasesFilterSelection,
  acquireCaseAccess,
  refreshCaseAccessTimer,
  resetCaseAccess,
  releaseCaseAccess,
  updateProcessInstance,
  refreshHoldSubmission
} = codeBenchActions;

const { navigateCreateCase } = createCaseActions;

const {
  showMergeCasesModal,
  hideMergeCasesModal,
  fetchMergeableCases,
  splitCase
} = mergeCasesActions;

const { showAttachDocsModal } = attachDocsActions;

const {
  updateValue,
  updateCase,
  loadAllPatientDetailOptions
} = caseEditsActions.caseEditsActions;

import { AmplifyState } from '@codametrix/ui-common';

export default {
  ampUI: { ...AmplifyCore.state.ampUI },
  invoiceMetadata: { ...AmplifyCore.state.invoiceMetadata },
  codeBench: { ...AmplifyCore.state.codeBenchState },
  launch: { ...AmplifyCore.state.launch },
  eula: { ...AmplifyState },
  capabilities: { ...AmplifyCore.state.capabilities },
  improvements: { ...AmplifyCore.state.improvements }
};

type AmplifyDefaultState = {
  ampUI: typeof AmplifyCore.state.ampUI;
  invoiceMetadata: typeof AmplifyCore.state.invoiceMetadata;
  codeBench: typeof AmplifyCore.state.codeBenchState;
  launch: typeof AmplifyCore.state.launch;
  eula: typeof AmplifyState;
  capabilities: typeof AmplifyCore.state.capabilities;
  improvements: typeof AmplifyCore.state.improvements;
};

// state : AmplifyDefaultState
export const mapStateToCodeBenchProps = function(
  state: any
): Accelerate.BenchStateData {
  const location_state = state?.router?.location?.state;
  const cursorAPIContext = location_state
    ? { ...location_state }
    : { ...AmplifyCore.state.capabilities.cursorAPIContext };

  return {
    ...state.codeBench,
    ...state.ampUI,
    capabilities: state.capabilities,
    improvements: state.improvements,
    caseEdits: state.caseEdits?.caseEdits,
    cursorAPIContext,
    htmlNotes: state?.cases?.htmlNotes ?? state?.codeBench?.htmlNotes,
    roles: state?.cases?.roles ?? [],
    caseRun: state?.cases?.activeItem,
    caseAccessTime: state?.codeBench?.caseAccessTime,
    customClaimsRelatedCases: state?.codeBench?.customClaimsRelatedCases,
    customClaimsRelatedCasesLoadState:
      state?.codeBench?.customClaimsRelatedCasesLoadState,
    backToWorklistPath: state.ui.backToWorklistPath,
    propertyConfig: state?.codeBench?.propertyConfig
  };
};

export const mapDispatchToCodeBenchProps = (
  dispatch: any
): Accelerate.CodeBenchPanelMethods => {
  const runDispatchable = buildDispatchable(dispatch);
  let debouncedFunc: any;

  return {
    updateRelatedCasesFilterSelection: (
      options: CMxCommonApp.FilterSelection
    ) => {
      dispatch(updateRelatedCasesFilterSelection(options));
    },
    setUnresolvedDocuments: (value: boolean) => {
      dispatch(setUnresolvedDocuments(value));
    },
    setActiveMiniTab: (activeTabName: string) => {
      dispatch(setActiveMiniTab(activeTabName));
    },
    setActiveVerticalMiniTab: (activeVerticalTabName: string) => {
      dispatch(setActiveVerticalMiniTab(activeVerticalTabName));
    },
    onProviderSearch: (query: CMxCommonApp.LookupQuery) => {
      dispatch(providerSearch(query));
    },
    handleConfirm: async (actionItem: Accelerate.ActionItem) => {
      if (actionItem.action === 'DELETE_TRANSACTION') {
        await dispatch(
          removeTransaction(actionItem as CMxCommonApp.TransactionAction)
        );
      }
      dispatch(handleConfirm(actionItem));
    },
    handleConfirmDismiss: (actionItem: Accelerate.ActionItem) => {
      dispatch(dismissConfirm(actionItem));
    },
    onLoadFromURLMatch: (params: any) => {
      runDispatchable(() => loadFromURLMatch(params));
    },
    loadWorkItemDetails: (case_uid: string, caserun_uid: string) => {},
    acquireCaseAccess: ({
      case_uid,
      processInstance,
      callback
    }: {
      case_uid: string;
      processInstance: AmplifyAPI.ProcessInstance;
      callback?: () => void;
    }) => {
      dispatch(acquireCaseAccess({ case_uid, processInstance, callback }));
    },
    refreshCaseAccessTimer: (case_uid: string) => {
      dispatch(refreshCaseAccessTimer(case_uid));
    },
    resetCaseAccess: processInstance => {
      dispatch(resetCaseAccess(processInstance));
    },
    releaseCaseAccess: (case_uid: string) => {
      dispatch(releaseCaseAccess(case_uid));
    },
    onSearchClear: (
      codeQuery: Accelerate.CodeActionContextual,
      searchResultsLookupKey?: string
    ) => {
      const searchId = codeQuery.context?.chargeSession?.transactionId ?? '';
      dispatch(clearSearchResults(searchId));
      if (searchResultsLookupKey) {
        dispatch(clearSearchResults(searchResultsLookupKey));
      }
    },
    onFeatureActivation: (selection: CMxCommonApp.ChargeSessionSelection) => {
      dispatch(featureSelection(selection));
    },
    onCodeSearch: (codeQuery: Accelerate.CodeQuery) => {
      dispatch(codeSearch(codeQuery));
    },
    onChargeSessionAction: (
      transactionAction: CMxCommonApp.TransactionAction
    ) => {
      dispatch(showConfirm(transactionAction));
      //;
    },
    onCodeSearchSelection: (
      searchSelection: Accelerate.CodeAddActionPayload
    ) => {
      // codes are added through search selection
      dispatch(codeAdd(searchSelection));
    },
    handleAddAllCodes: (searchSelection: Accelerate.CodesAddCodeBench) => {
      dispatch(codesAdd(searchSelection));
    },
    handleRemoveAllCodes: (codeChange: Accelerate.CodeChange) => {
      dispatch(codesRemove(codeChange));
    },
    createTransactionAndAddCode: (
      searchSelection: Accelerate.CodeAddActionPayload
    ) => {
      dispatch(createTransactionAndAddCode(searchSelection));
    },
    onPopUpNavigate: (caseNavigate: Accelerate.CaseNavigate) => {
      if (caseNavigate.replace) {
        dispatch(loadCaseFromId({ caseId: caseNavigate.caseId }));
      } else {
        sessionStorage.setItem('channel', authenticationChannel.name);
        dispatch(popupNavigate(caseNavigate));
      }
    },
    onCodeUpdate: (changeDetail: Accelerate.CodeChange) => {
      dispatch(codeUpdate(changeDetail));
    },
    onCodeRemove: (changeDetail: Accelerate.CodeChange) => {
      dispatch(codeRemove(changeDetail));
    },
    onTimeBasedCodeAdd: (
      codeChange: Accelerate.CodeChange,
      time: string,
      age: string
    ) => {
      dispatch(timeBasedCodeAdd({ codeChange, time, age }));
    },
    onTimeBasedCodeUpdate: (
      codeChange: Accelerate.CodeChange,
      time: string,
      age: string
    ) => {
      dispatch(timeBasedCodeUpdate({ codeChange, time, age }));
    },
    onTransactionOrderChange: (
      transactionReorderDetail: CMxCommonApp.TransactionReorderDetail
    ) => {
      dispatch(transactionOrderChange(transactionReorderDetail));
    },
    onCodeSearchDrop: (changeDetail: Accelerate.CodeChange) => {
      dispatch(codeSearchDrop(changeDetail));
    },
    onModalAddChargeOpen: () => {
      dispatch(openAddChargeModal());
    },
    onModalAddChargeClose: e => {
      e.preventDefault();
      dispatch(closeAddChargeModal());
    },
    handleAddCharge: (newInvoice: Accelerate.NewInvoice) => {
      dispatch(addTransaction(newInvoice));
    },
    handleTimer: () => {
      setTimeout(() => {
        dispatch(submittedFeedbackTimer());
      }, 700);
    },
    onInvoiceEdit: async (
      invoice: CMxCommonApp.CodableInvoice,
      processInstance: AmplifyAPI.ProcessInstance
    ) => {
      await dispatch(getInvoiceOptions(processInstance));
      dispatch(selectInvoiceToEdit(invoice));
    },
    onInvoiceAddition: async (
      invoice: CMxCommonApp.CodableInvoice,
      processInstance: AmplifyAPI.ProcessInstance
    ) => {
      await dispatch(getInvoiceOptions(processInstance));
      dispatch(selectInvoiceToAdd(invoice));
    },
    onInvoiceRemove: (invoiceDeleteParams: Accelerate.InvoiceDeleteParams) => {
      dispatch(removeInvoice(invoiceDeleteParams));
    },
    onLoad: (caseRun: CMxAPI.CaseRun) => {
      dispatch(fetchProcessInstance(caseRun));
    },
    onPrompt: (action: string) => {
      dispatch(promptClose());
    },
    onPopUpClose: () => {
      dispatch(popupClose());
    },
    showPatientInfo: caseRun => {
      dispatch(navigatePatient(caseRun));
    },
    showProviderInfo: (providerInfo: CMxCommonApp.ProviderSearchParams) => {
      dispatch(navigateProvider(providerInfo));
    },
    showCoderNotesInfo: (coderNotesParams: CMxCommonApp.CoderNotesParams) => {
      dispatch(navigateCoderNotes(coderNotesParams));
    },
    handleTraversal: (caseDescriptor: string) => {
      dispatch(navigateDetail(caseDescriptor));
    },
    onInvoicesCancel: (processInstance: AmplifyAPI.ProcessInstance) => {
      dispatch(cancelInvoicesPopup(processInstance));
    },
    onInvoicesSubmisson: async (submission: AmplifyAPI.Submission) => {
      // This will submit the invoices.  At this point, the case
      // is no longer codable.
      await dispatch(submitInvoice(submission));
    },
    onTransactionSharedDiagnosisChange: (
      changeDetail: CMxCommonApp.TransactionSharedCodeChange
    ) => {
      dispatch(txnSharedCodeAction(changeDetail));
    },
    // Inactive methods at the moment.  They're required bc of the amount that
    // we're leveraging the case detail.
    onCaseAction: (action: any) => {},
    onFeatureSelection: (selection: CMxArtifacts.FeatureSelection) => {},
    openChildWindow: (windowOpenArgs: CMxCommonApp.WindowOpenArguments) => {
      dispatch(openWindow(windowOpenArgs));
    },
    openAmplifyCase: (amplifyLaunchConfig: any) => {
      const sl = appServiceLines.toServiceLineSlug(
        appServiceLines.normalizeServiceLineName(String(amplifyLaunchConfig.serviceLine ?? ''))
      );
      dispatch(
        launchPageActions.navigationIntent({
          intent: 'CASE_DETAIL',
          url: `/cmx/worklist/${sl}/case/${amplifyLaunchConfig.caseId}/case-run/${amplifyLaunchConfig.id}/`
        })
      );
    },
    toggleArtifacts: (showAll: boolean) => {},
    showList: (serviceLine: string, refreshList?: boolean) => {},
    onNavigate: (caseId: string, replace?: boolean) => {},
    setActiveProcess: (activeProcess: CMxCommonApp.ActiveProcessPayload) => {},
    hideFeedback: () => {
      dispatch(hideFeedback());
    },
    deleteSizeExpWarning: () => {
      dispatch(deleteSizeExpWarning());
    },
    hideSubmittedFeedback: () => {
      dispatch(hideSubmittedFeedback());
    },
    handleEnableTechPro: (
      transactionCodeChange: CMxCommonApp.TechCodableTransaction
    ) => {
      dispatch(enableTechPro(transactionCodeChange));
    },
    handleDisableTechPro: (
      transactionCodeChange: CMxCommonApp.TechCodableTransaction
    ) => {
      dispatch(disableTechPro(transactionCodeChange));
    },
    hidevitalwareIssuesModal: () => {
      dispatch(hidevitalwareIssuesModal());
    },
    showHoldCaseModal: () => {
      dispatch(showHoldCaseModal());
    },
    hideHoldCaseModal: () => {
      dispatch(hideHoldCaseModal());
    },
    showCaseCommentModal: () => {
      dispatch(showCaseCommentModal());
    },
    hideCaseCommentModal: () => {
      dispatch(hideCaseCommentModal());
    },
    showExclusionCaseModal: () => {
      dispatch(showExclusionCaseModal());
    },
    hideExclusionCaseModal: () => {
      dispatch(hideExclusionCaseModal());
    },
    toggleLateCaseClearModal: (toggle: boolean) => {
      dispatch(toggleLateCaseClearModal(toggle));
    },
    clearLateCaseNotification: (
      processInstance: AmplifyAPI.ProcessInstance
    ) => {
      dispatch(clearLateCaseNotification(processInstance));
    },
    showSplitCaseModal: () => {
      dispatch(showSplitCaseModal());
    },
    hideSplitCaseModal: () => {
      dispatch(hideSplitCaseModal());
    },
    splitCase: (processInstance: AmplifyAPI.ProcessInstance) => {
      dispatch(splitCase(processInstance));
    },
    toggleChargeableCase: (
      toggleChargeableCaseObject: Accelerate.ToggleChargeableCaseType
    ) => {
      dispatch(toggleChargeableCase(toggleChargeableCaseObject));
    },
    holdCase: (holdCaseObject: CMxAPI.HoldCaseType) => {
      dispatch(holdCase(holdCaseObject));
    },
    onDocumentImprovementAdd: (
      improvementRequest: AmplifyAPI.ImprovementRequest
    ) => {
      dispatch(addImprovement(improvementRequest));
    },
    onDocumentImprovementRemove: (
      improvementRequest: AmplifyAPI.ImprovementRequest
    ) => {
      dispatch(removeImprovement(improvementRequest));
    },
    onDocumentImprovementSearch: (codeQuery: CMxCommonApp.CodeQuery) => {
      dispatch(improvementSearch(codeQuery));
    },
    onDocumentImprovementUpdate: (
      documentImprovement: AmplifyAPI.ImprovementRequest
    ) => {
      dispatch(updateImprovement(documentImprovement));
    },
    onProviderAdd: (improvementRequest: AmplifyAPI.ImprovementRequest) => {
      dispatch(addImprovementProvider(improvementRequest));
    },
    onProviderUpdate: (improvementRequest: AmplifyAPI.ImprovementRequest) => {
      dispatch(updateImprovementProvider(improvementRequest));
    },
    onProviderRemove: (documentImprovement: AmplifyAPI.ImprovementRequest) => {
      dispatch(removeImprovementProvider(documentImprovement));
    },
    showAmplifyFeedback: (feedback: AmplifyAPI.AmplifyFeedback) => {
      dispatch(amplifyFeedback(feedback));
    },
    updateValue: (updatedFieldAndValue: any) => {
      dispatch(updateValue(updatedFieldAndValue));
    },
    updateCase: (updatesAndInfo: any) => {
      dispatch(updateCase(updatesAndInfo));
    },
    navigate: (url: string) => {
      dispatch(launchPageActions.navigationIntent({ intent: 'CASE_DETAIL', url }));
    },
    toggleSubmitOldCaseModal: () => {
      dispatch(toggleSubmitOldCaseModal());
    },
    getCaseVersions: async (processInstance: AmplifyAPI.ProcessInstance) => {
      await dispatch(getCaseVersions(processInstance));
    },
    onCursorAction: (cursorAPIPayload: CMxCommonApp.CursorAPIPayload) => {},
    loadServicedeskContext: (
      cursorAPIContext: CMxCommonApp.CursorAPIContext
    ) => {
      dispatch(loadCursorAPIContext(cursorAPIContext));
    },
    loadRoles: (roles: string[]) => {
      dispatch(loadRoles(roles));
    },
    loadAllPatientDetailOptions: (tenantId: string, facility: string) => {
      dispatch(
        loadAllPatientDetailOptions({ activeTenantId: tenantId, facility })
      );
    },
    getFlagItems: (activeItem: CMxAPI.CaseRunV2) => {
      dispatch(getFlagItems(activeItem));
    },
    getCasesWithEncounter: (harListPayload: CMxCommonApp.HARListPayload) => {
      dispatch(getCasesWithEncounter(harListPayload));
    },
    showMergeCasesModal: (
      mergeCaseModalProps: CMxCommonApp.MergeCaseModalProps
    ) => {
      dispatch(showMergeCasesModal(mergeCaseModalProps));
    },
    navigateCreateCase: (caseRun: CMxAPI.CaseRunV2) => {
      dispatch(navigateCreateCase(caseRun));
    },
    showAttachDocsModal: (caseRun: CMxAPI.CaseRunV2) => {
      dispatch(showAttachDocsModal(caseRun));
    },
    hideMergeCasesModal: () => {
      dispatch(hideMergeCasesModal());
    },
    fetchMergeableCases: (
      mergeableCasesParams: CMxAPI.MergeableCasesParams
    ) => {
      dispatch(fetchMergeableCases(mergeableCasesParams));
    },
    setActiveNote: (activeNote: CMxCommonApp.DecoratedNote) => {
      dispatch(setActiveNote(activeNote));
    },
    hideSideNavBar: () => {
      dispatch(codeBenchActions.hideSideNavBar());
    },
    showSideNavBar: () => {
      dispatch(codeBenchActions.showSideNavBar());
    },
    onCreateCQATransaction: () => {
      dispatch(gradeBenchPanelActions.createCQATransaction);
    },
    onDeleteCQATransaction: () => {
      dispatch(gradeBenchPanelActions.deleteCQATransaction);
    },
    fetchCoderConfig: (args: CMxCommonApp.SectionAPIArguments) => {
      dispatch(coderConfig.getCoderConfig(args));
    },
    refreshHoldSubmission:(caseRun: CMxAPI.CaseRun) => {
      setTimeout(() => {
            dispatch(updateProcessInstance({serviceLine:caseRun.service_line, guid:caseRun.process_instance_guid}));
              dispatch(refreshHoldSubmission());
      }, 3000);
  
    }
  };
};
